module.exports = __webpack_public_path__ + "img/DE00093.a58e64ac.png";